const API_URL = process.env.REACT_APP_API_URL || "https://startingfive.onrender.com";
export default API_URL;